import script from "./VAppSidebarMobile.vue?vue&type=script&setup=true&lang=ts"
export * from "./VAppSidebarMobile.vue?vue&type=script&setup=true&lang=ts"

import "./VAppSidebarMobile.vue?vue&type=style&index=0&id=02bcdaf4&lang=scss"

const __exports__ = script;

export default __exports__